import { get, post, deleteRequest } from 'helpers/api';
import { isBlank } from 'helpers/string_helpers';
import { pickBy } from 'lodash';

import { getSavedSearchIndexPath } from '../selectors/paths';
import { getDeleteSavedSearch } from '../selectors/saved_searches';

import { toggleAlert } from './ui';
import { setFullQuery } from './query';
import { retrieveRecords } from './search';

export const SET_SAVED_SEARCHES = 'SET_SAVED_SEARCHES';
export const setSavedSearches = searches => ({
  searches,
  type: SET_SAVED_SEARCHES
});

export const START_LOAD_SEARCHES = 'START_LOAD_SEARCHES';
export const startLoadSearches = () => ({
  type: START_LOAD_SEARCHES
});

export const START_DELETE_SEARCH = 'START_DELETE_SEARCH';
export const startDeleteSearch = search => ({
  search,
  type: START_DELETE_SEARCH
});

export const END_DELETE_SEARCH = 'END_DELETE_SEARCH';
export const endDeleteSearch = () => ({
  type: END_DELETE_SEARCH
});

export const loadSearchQuery = search => (
  (dispatch) => {
    const query = filterQuery(search.query);
    dispatch(setFullQuery(query));
    dispatch(retrieveRecords());
  }
);

export const loadSavedSearches = () => (
  (dispatch, getState) => {
    const path = getSavedSearchIndexPath(getState());
    dispatch(startLoadSearches());

    return get(path, { params: { modelType: "Requirements::Set" } }).then((searches) => {
      dispatch(setSavedSearches(searches));
    });
  }
);

export const saveSavedSearch = (name) => {
  return (dispatch, getState) => {
    const state = getState();
    const path = getSavedSearchIndexPath(state);
    const query = filterQuery(state.query);

    return post(path, {
      savedSearch: {
        name: name,
        modelType: "Requirements::Set",
        query: query,
        coordinates: {}
      }
    }).then(({ message }) => {
      dispatch(loadSavedSearches());
      dispatch(toggleAlert(message, false));
    }).catch(() => {
      dispatch(toggleAlert("This search already exists. Please try a new query", true));
    });
  };
};

export const deleteSavedSearch = () => (
  (dispatch, getState) => {
    const path = getSavedSearchIndexPath(getState());
    const deletedSavedSearch = getDeleteSavedSearch(getState());
    return deleteRequest(`${path}/${deletedSavedSearch.id}`).then(({ message }) => {
      dispatch(loadSavedSearches());
      dispatch(endDeleteSearch());
      dispatch(toggleAlert(message, true));
    }).catch(() => {
      dispatch(toggleAlert("Unable to delete search.", true));
    });
  }
);

const filterNestedObject = (obj) => {
  const filteredObject = pickBy(obj, (value) => {
    if (Array.isArray(value)) return value.length > 0;
    return !isBlank(value);
  });

  const isObjectEmpty = Object.keys(filteredObject).length == 0;
  return isObjectEmpty ? null : filteredObject;
};

const filterQuery = (query) => {
  const { page, pageSize, propertyFilter: { sizeUnits, ...propFilter }, ...filteredQuery } = query;

  propFilter.sizeUnits = isBlank(sizeUnits) ? "sf" : sizeUnits;
  filteredQuery.addressFilter = filterNestedObject(filteredQuery.addressFilter);
  filteredQuery.propertyFilter = filterNestedObject(propFilter);

  return filterNestedObject(filteredQuery);
};
